module.exports = __webpack_public_path__ + "static/media/sunbeam-home-hero-bg.b1d5b1b2.jpg";